import { DataService } from "./DataService";

export class ConfigService {
    private _dataService = new DataService();

    private _bchDepositPkh?: string;

    getBchDepositPkh = async () => {
        if (!this._bchDepositPkh) {
            const result = await this._dataService.resources.Config.getAll({
                queryParams: { filter: { key: "bch_deposit_pkh" } },
            })
                .then((data) => data[0])
                .catch((e) => console.log("e :", e));

            if (!result) {
                throw "Wrong configuration: deposit wallet not defined";
            }

            this._bchDepositPkh = result.value!;
        }

        return this._bchDepositPkh;
    }
}
export default new ConfigService()